<template>
  <div class="pneu-lancamento ml-4 mr-4">
    <div class="row">
      <div class="col-5">
        <div class="col-12">
          <div>
            <b-row>
              <b-col cols="7">
                <label for="input-filial">Empresa</label>
                <div>
                  <b-form-select
                    id="fun-empresa"
                    v-model="pneu.empresa_id"
                    required
                    :options="empresas"
                    class="mb-3"
                    text-field="empresa"
                    @change="loadFilial()"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="5">
                <label for="input-filial">Filial</label>
                <div>
                  <b-form-select
                    id="fun-filial"
                    v-model="pneu.filial_id"
                    required
                    :options="filiais"
                    class="mb-3"
                    text-field="filial"
                    @change="loadPneuSaldo()"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">Nº de fogo</label>
                <b-form-input
                  @keyup.enter="loadPneu()"
                  v-model="pneu.nrofogo"
                  required
                  placeholder="Nº de fogo"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <!--    
                    <b-col cols="1" >
                    <label for="input-live">Carro</label> 
                    <b-form-input @keyup.enter="loadVeiculo()"  v-model="tabela.carro"  placeholder=""></b-form-input>              
                    </b-col> 
                -->

              <b-col cols="4">
                <label for="input-pnefabricante">FABRICANTE</label>
                <div>
                  <b-form-select
                    v-model="pneu.fabricante_id"
                    required
                    :options="fabricantes"
                    class="mb-3"
                    text-field="fabricante"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="3">
                <label for="input-chassifabricante">MEDIDA</label>
                <div>
                  <b-form-select
                    v-model="pneu.medida_id"
                    required
                    :options="modelos"
                    class="mb-3"
                    text-field="medida"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="3">
                <label for="input-chassifabricante">VIDA</label>
                <div>
                  <b-form-select
                    v-model="pneu.vida_id"
                    required
                    :options="vidas"
                    class="mb-3"
                    text-field="vida"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6">
                <label for="input-pnefabricante">FORNECEDOR / CLIENTE</label>
                <div>
                  <b-form-select
                    v-model="pneu.fornecedor_id"
                    required
                    :options="fornecedores"
                    class="mb-3"
                    text-field="nome"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">Nº da NFS</label>
                <b-form-input
                  v-model="pneu.nfs"
                  placeholder="Nº da NFS"
                  v-b-tooltip.hover
                  title="Digite o nº da NFS"
                ></b-form-input>
              </b-col>

              <b-col cols="2">
                <div>
                  <label for="datepicker-placeholder">Data inicial</label>
                  <b-form-datepicker
                    id="dt_sol_inicial"
                    v-model="pneu.dt_emissao"
                    placeholder="Data inicial "
                    locale="pt-BR"
                    date-format-options="DD/MM/YYYY"
                  ></b-form-datepicker>
                </div>
              </b-col>

              <b-col cols="2" class="mb-2 mt-6">
                <label for="input-registro">Valor R$</label>
                <b-form-input
                  v-model="pneu.valor"
                  placeholder="valor do pneu R$"
                  v-b-tooltip.hover
                  title="Digite o valor do pneu"
                ></b-form-input>
              </b-col>

              <b-col cols="3">
                <label for="input-status">BORRACHA</label>
                <div>
                  <b-form-select
                    v-model="pneu.borracha_id"
                    required
                    :options="borrachas"
                    class="mb-3"
                    text-field="borracha"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="3">
                <label for="input-status">Desenho</label>
                <div>
                  <b-form-select
                    v-model="pneu.carcaca_id"
                    required
                    :options="desenhos"
                    class="mb-3"
                    text-field="desenho"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="3" class="mb-2 mt-6">
                <label for="input-registro">NUMERO DOT</label>
                <b-form-input
                  v-model="pneu.dotserie"
                  required
                  placeholder="Nº do carro"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col cols="3" class="mb-2 mt-6">
                <label for="input-registro">NÚMERO SÉRIE</label>
                <b-form-input
                  v-model="pneu.serie"
                  required
                  placeholder="Nº do carro"
                  v-b-tooltip.hover
                  title="Digite o prefixo do veiculo"
                ></b-form-input>
              </b-col>

              <b-col cols="4">
                <label for="input-status">Status</label>
                <div>
                  <b-form-select
                    v-model="pneu.status_id"
                    required
                    :options="statuss"
                    class="mb-3"
                    text-field="status"
                  >
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2">
                <label for="input-live">PREFIXO</label>
                <b-input-group-text>{{
                  pneu.prefixo ? pneu.prefixo : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">LIBRAS</label>
                <b-input-group-text>{{
                  pneu.libras ? pneu.libras : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">SULCO</label>
                <b-input-group-text>{{
                  pneu.sulco ? pneu.sulco : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">DATA CADASTRO</label>
                <b-input-group-text>{{
                  moment(pneu.dt_cadastro)
                    .format("DD/MM/YYYY HH:mm")
                    .replace("Data inválida", "-")
                }}</b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">DATA ALTERAÇÃO</label>
                <b-input-group-text>{{
                  pneu.dt_alteracao
                    ? moment(pneu.dt_alteracao).format("DD/MM/YYYY HH:mm")
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">DATA SUCATA</label>
                <b-input-group-text>{{
                  pneu.dt_sucata
                    ? moment(pneu.dt_sucata).format("DD/MM/YYYY HH:mm")
                    : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="3">
                <label for="input-live">DATA VENDA</label>
                <b-input-group-text>{{
                  pneu.dt_sucata
                    ? moment(pneu.dt_venda).format("DD/MM/YYYY HH:mm")
                    : "-"
                }}</b-input-group-text>
              </b-col>
            </b-row>

            <b-row class="mt-2 mb-2"> </b-row>

            <b-row class="mt-3">
              <b-col cols="4">
                <label for="input-live">KM VIDA ATUAL</label>
                <b-input-group-text>{{
                  pneu.km_vidaatual ? pneu.km_vidaatual : "-"
                }}</b-input-group-text>
              </b-col>

              <b-col cols="4">
                <b-form-checkbox
                  id="APP-status"
                  class="mb-3 mt-5"
                  v-model="pneu.nao_considera_na_media"
                  name="checkbox-2"
                  value="true"
                  unchecked-value="false"
                  checked="true"
                >
                  Não considerar na média
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-textarea
                  id="infoConteudo"
                  v-model="pneu.observacoes"
                  size="sm"
                  rows="6"
                  placeholder="Observações do pneu"
                ></b-form-textarea>
              </b-col>
            </b-row>

            <b-button class="mt-3" variant="success" block @click="postPneus()"
              >Gravar</b-button
            >
          </div>
        </div>
      </div>

      <div class="col-7">
        <b-row class="justify-content-center align-items-center">
          <b-card-group
            class="ml-3 mt-3 mb-3 d-flex justify-content-center"
            deck
          >
            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="primary"
              header="ESTOQUE"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ itemsFiltered.filter((s) => s.status_id === 1).length }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="success"
              header="RODANDO"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ itemsFiltered.filter((s) => s.status_id === 2).length }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="warning"
              header="RECAPADORA"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ itemsFiltered.filter((s) => s.status_id === 3).length }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="danger"
              header="SUCATA"
              header-bg-variant="danger"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ itemsFiltered.filter((s) => s.status_id === 5).length }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="primary"
              header="VENDIDO"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ itemsFiltered.filter((s) => s.status_id === 6).length }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="warning"
              header="VENDIDO COM CARRO"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ itemsFiltered.filter((s) => s.status_id === 7).length }}
                </h2>
              </b-card-text>
            </b-card>
          </b-card-group>

          <b-col cols="12" class="mb-3">
            <label for="input-busca">Pesquisa no grid</label>
            <b-form-input
              id="buscamonitoramento"
              v-model="search"
              required="required"
              placeholder="Pesquisar por Nº de fogo"
            ></b-form-input>
          </b-col>
        </b-row>
        <!--  TABLE DE DADOS                               -->
        <div class="col-12">
          <!--tbl de dados -->
          <b-table
            id="tbldefeitos"
            small
            hover
            striped
            sticky-header="660px"
            :items="itemsFiltered"
            :fields="situacaopneu"
          >
            <template slot="cell(actions)" slot-scope="data">
              <b-button
                @click="editpneuCabecalho(data.item)"
                v-b-modal.modal-multi-pneu
                title="Editar pneu"
                size="sm"
                variant="success"
                class="mr-2"
              >
                <i class="fa fa-exclamation-circle"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "ManutencaoRfiLancamento",

  /*
    computed: mapState(['user']),   
    */

  computed: {
    ...mapState(["user"]),
    itemsFiltered() {
      let valores = [];
      // const values = Object.values(obj);
      valores = this.pneussaldo.filter((item) => {
        return item.nrofogo.indexOf(this.search) > -1;
      });
      return valores;
    },
  },

  data: function () {
    return {
      //////////////
      pneus: [],
      pneu: {},
      filiais: [],
      fabricantes: [],
      modelos: [],
      vidas: [],
      borrachas: [],
      desenhos: [],
      statuss: [],
      pneussaldo: [],
      value_fornecedor: 0,
      fornecedores: [],

      isLoading: false,
      dt_abertura: "",
      empresas: [],
      filiais: [],

      empresasf: [],
      empresaf: {},
      filialf: {},
      pneus: [],
      operador: [],
      socorrista_carro: [],
      trocado_carro: [],
      socorristas: [],
      pneus: [],
      pneu: {},
      viacep: [],

      value_empresaf: [],

      defeitos: [],
      defeito: {},

      gruposi: [],
      subgruposi: [],
      defeitosi: [],

      gruposd: [],
      subgruposd: [],
      defeitosd: [],

      executante: {},
      executantes: [],
      lider: {},
      lideres: [],

      mode: "save",
      carregando: false,
      atualizando: false,

      grupo: {},
      grupos: [],
      subgrupo: {},
      subgrupos: [],
      defeito: {},
      defeitos: [],

      // gruposd:[],
      gruposd: {},
      subgrupod: {},
      subgruposd: [],
      defeitod: {},

      solicitante: {},
      solicitantes: [],

      socorrista: {},
      linhas: [],

      nropneu: [],

      pneueditdefeito: [],

      situacaojb: [],

      value_carro: "",
      value_carro_socorrista: "",
      value_carro_trocado: "",
      value_cep: "",
      value_solicitante: "",
      value_executante: "",
      value_socorrista: "",
      value_status: [],
      value_statusjb: [],
      value_tipo: [],
      value_lider: "",

      //garagem:{},
      tipos: [],
      search: "",

      lin: {},

      value_garagem: [], // [] lista

      value_observacoes: "",

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      situacaopneu: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "filial_id", label: "Filial", sortable: true },
        { key: "nrofogo", label: "Nro pneu", sortable: true },
        { key: "vida", label: "Vida", sortable: true },
        { key: "fabricante", label: "Fabricante", sortable: true },
        { key: "medida", label: "Medida", sortable: true },
        { key: "borracha", label: "Borracha", sortable: true },
        { key: "carcaca", label: "Carcaça", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Ações" },
      ],

      //////// defeitos da pneu
      listpneudefeitos: [
        { key: "pneu_id", label: "Nro pneu", sortable: true },

        { key: "id", label: "Nro defeito", sortable: true },

        { key: "grupoi", label: "grupo informado", sortable: true },
        { key: "subgrupoi", label: "Subgrupo informado", sortable: true },
        { key: "defeitoi", label: "Defeito informado", sortable: true },
        {
          key: "defeito_cancelado",
          label: "Cancelado",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },

        { key: "grupod", label: "Grupo diagnosticado", sortable: true },
        { key: "subgrupod", label: "Subgrupo diagnosticado", sortable: true },
        { key: "defeitod", label: "Defeito diagnosticado", sortable: true },
        {
          key: "defeito_causador",
          label: "Causador",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },

        { key: "executante_defeito", label: "Executante", sortable: true },
        {
          key: "dt_cadastro",
          label: "Cadastro_defeito",
          sortable: true,
          formatter: (value, key, pneueditdefeito) => {
            return moment(pneueditdefeito.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  filters: {
    dataFormatada(dt) {
      return dt.substring(0, 4);
    },
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    limparFiltro() {
      this.search = "";
    },

    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFilial() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_filial_erp,
              filial: emp.filial,
              empresa_id: emp.empresa_id,
            };
          });
        })
        .catch(showError);
    },

    ///CHASSI FABRICANTE
    loadFabricante() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/fabricante`;
      axios
        .get(url, { params })
        .then((res) => {
          this.fabricantes = res.data.map((gru) => {
            return { ...gru, value: gru.id, fabricante: gru.fabricante };
          });
        })
        .catch(showError);
    },

    ///CHASSI MODELO
    loadMedida() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/medida`;
      axios
        .get(url, { params })
        .then((res) => {
          this.modelos = res.data.map((sb) => {
            return { ...sb, value: sb.id, medida: sb.medida };
          });
        })
        .catch(showError);
    },

    loadVida() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/vida`;
      axios
        .get(url, { params })
        .then((res) => {
          this.vidas = res.data.map((sb) => {
            return { ...sb, value: sb.id, vida: sb.vida };
          });
        })
        .catch(showError);
    },

    loadBorracha() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/borracha`;
      axios
        .get(url, { params })
        .then((res) => {
          this.borrachas = res.data.map((gru) => {
            return { ...gru, value: gru.id, borracha: gru.borracha };
          });
        })
        .catch(showError);
    },

    loadCarcaca() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/desenho`;
      axios
        .get(url, { params })
        .then((res) => {
          this.desenhos = res.data.map((gru) => {
            return { ...gru, value: gru.id, desenho: gru.desenho };
          });
        })
        .catch(showError);
    },

    loadStattus() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/status`;
      axios
        .get(url, { params })
        .then((res) => {
          this.statuss = res.data.map((gru) => {
            return { ...gru, value: gru.id, status: gru.status };
          });
        })
        .catch(showError);
    },

    async postPneus() {
      let corpo = {
        psg: this.user.psg,
        id_funcionario: `${this.user.id_funcionario}`,
        id: this.pneu.id > 0 ? this.pneu.id : `${this.nropneu}`,
        dt_cadastro: `${this.pneu.dt_cadastro}`,
        empresa_id: `${this.pneu.empresa_id}`,
        filial_id: `${this.pneu.filial_id}`,
        nrofogo: `${this.pneu.nrofogo}`,
        fabricante_id: `${this.pneu.fabricante_id}`,
        medida_id: `${this.pneu.medida_id}`,
        vida_id: `${this.pneu.vida_id}`,
        borracha_id: `${this.pneu.borracha_id}`,
        carcaca_id: `${this.pneu.carcaca_id}`,
        status_id: `${this.pneu.status_id}`,
        dotserie: `${this.pneu.dotserie}`,
        serie: `${this.pneu.serie}`,
        observacoes: `${this.pneu.observacoes}`,
        nao_considera_na_media: `${this.pneu.nao_considera_na_media}`,
        nfs: `${this.pneu.nfs}`,
        valor: `${this.pneu.valor}`,
        dt_emissao: `${this.pneu.dt_emissao}`,
        fornecedor_id: `${this.pneu.fornecedor_id}`,
      };
      const url = `${baseApiUrl}/pneu/cadpneu`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset();
        })
        .catch(showError);
    },

    ///////////////////////////////// 31/12/2022 as 20:17h
    editpneuCabecalho(pneu) {
      this.pneu = { ...pneu };
    },

    loadPneuSaldo() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${[this.pneu.empresa_id]}`,
        filial_id: `${[this.pneu.filial_id]}`,
        origem: "websaldo",
      };
      const url = `${baseApiUrl}/pneu/pneu`;
      axios
        .get(url, { params })
        .then((res) => {
          this.pneussaldo = res.data;
        })
        .catch(showError);
    },

    loadPneu() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        nrofogo: `${this.pneu.nrofogo}`,
        origem: "web",
      };
      const url = `${baseApiUrl}/pneu/pneu`;

      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.pneu = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            pneu = {};
          }
        })
        .catch(showError);
    },

    reset() {
      this.pneu.id = "";
      this.pneu.fabricante_id = "";
      this.pneu.medida_id = "";
      this.pneu.vida_id = "";
      this.pneu.borracha_id = "";
      this.pneu.carcaca_id = "";
      this.pneu.status_id = "";
      this.pneu.dotserie = "";
      this.pneu.observacoes = "";
    },

    limparCorpo() {
      this.defeito = [];
      this.executante = [];
      this.lider = [];
      this.value_executante = "";
      this.value_lider = "";
      ///this.nropneu=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
    },

    novo() {
      this.pneu = {};
      this.defeito = {};
      this.pneueditdefeito = {};
    },

    loadPneuFornecedores() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
        origem: "listagem",
        area_id: 3,
      };
      const url = `${baseApiUrl}/fin/clifor`;
      axios
        .get(url, { params })
        .then((res) => {
          this.fornecedores = res.data.map((gru) => {
            return { ...gru, value: gru.id, nome: gru.nome };
          });
        })
        .catch(showError);
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadFilial();
    this.loadFabricante();
    this.loadMedida();
    this.loadVida();
    this.loadBorracha();
    this.loadCarcaca();
    this.loadStattus();
    this.loadPneuFornecedores();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#placa {
  font-size: 0.7em;
}

#modal-multi-pneu___BV_modal_content_ {
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;
}

#defeito-selecao {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-sos {
  background: rgb(199, 222, 218);
  border: 1px solid red;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-encerramento {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#pneu-nro {
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
}

#garagem {
  font-size: 12px;
  text-align: center;
}
</style>